const nasobilkaDvou = () => {
	return [
		{
			id: 1,
			priklad: '5 x 2',
			moznosti: [
				{
					id: 1,
					moznost: '6',
				},
				{
					id: 2,
					moznost: '12',
				},
				{
					id: 3,
					moznost: '8',
				},
				{
					id: 4,
					moznost: '10',
				},
			],
			vysledek: '10',
		},
		{
			id: 2,
			priklad: '18 : 2',
			moznosti: [
				{
					id: 1,
					moznost: '6',
				},
				{
					id: 2,
					moznost: '7',
				},
				{
					id: 3,
					moznost: '9',
				},
				{
					id: 4,
					moznost: '8',
				},
			],
			vysledek: '9',
		},
		{
			id: 3,
			priklad: '10 x 2',
			moznosti: [
				{
					id: 1,
					moznost: '20',
				},
				{
					id: 2,
					moznost: '18',
				},
				{
					id: 3,
					moznost: '16',
				},
				{
					id: 4,
					moznost: '14',
				},
			],
			vysledek: '20',
		},
		{
			id: 4,
			priklad: '14 : 2',
			moznosti: [
				{
					id: 1,
					moznost: '8',
				},
				{
					id: 2,
					moznost: '7',
				},
				{
					id: 3,
					moznost: '9',
				},
				{
					id: 4,
					moznost: '6',
				},
			],
			vysledek: '7',
		},
		{
			id: 5,
			priklad: '2 x 2',
			moznosti: [
				{
					id: 1,
					moznost: '6',
				},
				{
					id: 2,
					moznost: '8',
				},
				{
					id: 3,
					moznost: '4',
				},
				{
					id: 4,
					moznost: '2',
				},
			],
			vysledek: '4',
		},
		{
			id: 6,
			priklad: '6 x 2',
			moznosti: [
				{
					id: 1,
					moznost: '10',
				},
				{
					id: 2,
					moznost: '14',
				},
				{
					id: 3,
					moznost: '12',
				},
				{
					id: 4,
					moznost: '16',
				},
			],
			vysledek: '12',
		},
		{
			id: 7,
			priklad: '4 x 2',
			moznosti: [
				{
					id: 1,
					moznost: '12',
				},
				{
					id: 2,
					moznost: '10',
				},
				{
					id: 3,
					moznost: '8',
				},
				{
					id: 4,
					moznost: '6',
				},
			],
			vysledek: '8',
		},
		{
			id: 8,
			priklad: '20 : 2',
			moznosti: [
				{
					id: 1,
					moznost: '10',
				},
				{
					id: 2,
					moznost: '9',
				},
				{
					id: 3,
					moznost: '8',
				},
				{
					id: 4,
					moznost: '7',
				},
			],
			vysledek: '10',
		},
		{
			id: 9,
			priklad: '2 x 6',
			moznosti: [
				{
					id: 1,
					moznost: '12',
				},
				{
					id: 2,
					moznost: '14',
				},
				{
					id: 3,
					moznost: '16',
				},
				{
					id: 4,
					moznost: '10',
				},
			],
			vysledek: '12',
		},
		{
			id: 10,
			priklad: '10 : 2',
			moznosti: [
				{
					id: 1,
					moznost: '6',
				},
				{
					id: 2,
					moznost: '5',
				},
				{
					id: 3,
					moznost: '7',
				},
				{
					id: 4,
					moznost: '8',
				},
			],
			vysledek: '5',
		},
		{
			id: 11,
			priklad: '4 : 2',
			moznosti: [
				{
					id: 1,
					moznost: '3',
				},
				{
					id: 2,
					moznost: '2',
				},
				{
					id: 3,
					moznost: '4',
				},
				{
					id: 4,
					moznost: '5',
				},
			],
			vysledek: '2',
		},
		{
			id: 12,
			priklad: '2 : 2',
			moznosti: [
				{
					id: 1,
					moznost: '1',
				},
				{
					id: 2,
					moznost: '2',
				},
				{
					id: 3,
					moznost: '0',
				},
				{
					id: 4,
					moznost: '4',
				},
			],
			vysledek: '1',
		},
		{
			id: 13,
			priklad: '0 x 2',
			moznosti: [
				{
					id: 1,
					moznost: '3',
				},
				{
					id: 2,
					moznost: '2',
				},
				{
					id: 3,
					moznost: '1',
				},
				{
					id: 4,
					moznost: '0',
				},
			],
			vysledek: '0',
		},
		{
			id: 14,
			priklad: '0 : 2',
			moznosti: [
				{
					id: 1,
					moznost: '1',
				},
				{
					id: 2,
					moznost: '0',
				},
				{
					id: 3,
					moznost: '2',
				},
				{
					id: 4,
					moznost: '3',
				},
			],
			vysledek: '0',
		},
		{
			id: 15,
			priklad: '2 x 1',
			moznosti: [
				{
					id: 1,
					moznost: '1',
				},
				{
					id: 2,
					moznost: '6',
				},
				{
					id: 3,
					moznost: '4',
				},
				{
					id: 4,
					moznost: '2',
				},
			],
			vysledek: '2',
		},
		{
			id: 16,
			priklad: '8 x 2',
			moznosti: [
				{
					id: 1,
					moznost: '18',
				},
				{
					id: 2,
					moznost: '16',
				},
				{
					id: 3,
					moznost: '14',
				},
				{
					id: 4,
					moznost: '20',
				},
			],
			vysledek: '16',
		},
		{
			id: 17,
			priklad: '16 : 2',
			moznosti: [
				{
					id: 1,
					moznost: '7',
				},
				{
					id: 2,
					moznost: '8',
				},
				{
					id: 3,
					moznost: '9',
				},
				{
					id: 4,
					moznost: '6',
				},
			],
			vysledek: '8',
		},
		{
			id: 18,
			priklad: '4 x 2',
			moznosti: [
				{
					id: 1,
					moznost: '8',
				},
				{
					id: 2,
					moznost: '10',
				},
				{
					id: 3,
					moznost: '6',
				},
				{
					id: 4,
					moznost: '12',
				},
			],
			vysledek: '8',
		},
		{
			id: 19,
			priklad: '2 x 6',
			moznosti: [
				{
					id: 1,
					moznost: '10',
				},
				{
					id: 2,
					moznost: '16',
				},
				{
					id: 3,
					moznost: '12',
				},
				{
					id: 4,
					moznost: '14',
				},
			],
			vysledek: '12',
		},
		{
			id: 20,
			priklad: '2 x 9',
			moznosti: [
				{
					id: 1,
					moznost: '20',
				},
				{
					id: 2,
					moznost: '14',
				},
				{
					id: 3,
					moznost: '16',
				},
				{
					id: 4,
					moznost: '18',
				},
			],
			vysledek: '18',
		},
		{
			id: 21,
			priklad: '2 x 5',
			moznosti: [
				{
					id: 1,
					moznost: '10',
				},
				{
					id: 2,
					moznost: '14',
				},
				{
					id: 3,
					moznost: '16',
				},
				{
					id: 4,
					moznost: '12',
				},
			],
			vysledek: '10',
		},
		{
			id: 22,
			priklad: '2 x 10',
			moznosti: [
				{
					id: 1,
					moznost: '14',
				},
				{
					id: 2,
					moznost: '18',
				},
				{
					id: 3,
					moznost: '16',
				},
				{
					id: 4,
					moznost: '20',
				},
			],
			vysledek: '20',
		},
		{
			id: 23,
			priklad: '2 x 4',
			moznosti: [
				{
					id: 1,
					moznost: '10',
				},
				{
					id: 2,
					moznost: '8',
				},
				{
					id: 3,
					moznost: '6',
				},
				{
					id: 4,
					moznost: '12',
				},
			],
			vysledek: '8',
		},
		{
			id: 24,
			priklad: '2 x 8',
			moznosti: [
				{
					id: 1,
					moznost: '14',
				},
				{
					id: 2,
					moznost: '18',
				},
				{
					id: 3,
					moznost: '16',
				},
				{
					id: 4,
					moznost: '12',
				},
			],
			vysledek: '16',
		},
		{
			id: 25,
			priklad: '6 x 2',
			moznosti: [
				{
					id: 1,
					moznost: '14',
				},
				{
					id: 2,
					moznost: '16',
				},
				{
					id: 3,
					moznost: '10',
				},
				{
					id: 4,
					moznost: '12',
				},
			],
			vysledek: '12',
		},
		{
			id: 26,
			priklad: '9 x 2',
			moznosti: [
				{
					id: 1,
					moznost: '20',
				},
				{
					id: 2,
					moznost: '16',
				},
				{
					id: 3,
					moznost: '18',
				},
				{
					id: 4,
					moznost: '14',
				},
			],
			vysledek: '18',
		},
	];
};

export default nasobilkaDvou;
